import { ProcessQuestionTypeModel } from '../models/questions.model';
import { v4 as uuid } from 'uuid';

export const questionSuggestions = [
  {
    id: null,
    uuid: uuid(),
    question_text: {
      nor: 'Har du førerkort?',
      eng: "Do you have a driver's license?",
    },
    type: ProcessQuestionTypeModel.YesNo,
    reject_on_failure: false,
    is_required: false,
    alternatives: [
      {
        id: null,
        answer_text: { nor: 'Ja', eng: 'Yes' },
        is_correct: true,
      },
      {
        id: null,
        answer_text: { nor: 'Nei', eng: 'No' },
        is_correct: false,
      },
    ],
  },
  {
    id: null,
    uuid: uuid(),
    question_text: {
      nor: 'Har du tilgang til egen bil?',
      eng: 'Do you have a car?',
    },
    type: ProcessQuestionTypeModel.YesNo,
    reject_on_failure: false,
    is_required: false,
    alternatives: [
      {
        id: null,
        answer_text: { nor: 'Ja', eng: 'Yes' },
        is_correct: true,
      },
      {
        id: null,
        answer_text: { nor: 'Nei', eng: 'No' },
        is_correct: false,
      },
    ],
  },
  {
    id: null,
    uuid: uuid(),
    question_text: {
      nor: 'Er du over 21 år? (hvis alder er lovpliktig)',
      eng: 'Are you above 21 years of age? (if legally required)',
    },
    type: ProcessQuestionTypeModel.YesNo,
    reject_on_failure: false,
    is_required: false,
    alternatives: [
      {
        id: null,
        answer_text: { nor: 'Ja', eng: 'Yes' },
        is_correct: true,
      },
      {
        id: null,
        answer_text: { nor: 'Nei', eng: 'No' },
        is_correct: false,
      },
    ],
  },
  {
    id: null,
    uuid: uuid(),
    question_text: {
      nor: 'Kan du arbeide kvelder?',
      eng: 'Can you work on evenings?',
    },
    type: ProcessQuestionTypeModel.YesNo,
    reject_on_failure: false,
    is_required: false,
    alternatives: [
      {
        id: null,
        answer_text: { nor: 'Ja', eng: 'Yes' },
        is_correct: true,
      },
      {
        id: null,
        answer_text: { nor: 'Nei', eng: 'No' },
        is_correct: false,
      },
    ],
  },
  {
    id: null,
    uuid: uuid(),
    question_text: {
      nor: 'Kan du arbeide i helger?',
      eng: 'Can you work on weekends?',
    },
    type: ProcessQuestionTypeModel.YesNo,
    reject_on_failure: false,
    is_required: false,
    alternatives: [
      {
        id: null,
        answer_text: { nor: 'Ja', eng: 'Yes' },
        is_correct: true,
      },
      {
        id: null,
        answer_text: { nor: 'Nei', eng: 'No' },
        is_correct: false,
      },
    ],
  },
  {
    id: null,
    uuid: uuid(),
    question_text: {
      nor: 'Har du minimum 5 års erfaring med salg?',
      eng: 'Do you have minimum 5 years of sales experience?',
    },
    type: ProcessQuestionTypeModel.YesNo,
    reject_on_failure: false,
    is_required: false,
    alternatives: [
      {
        id: null,
        answer_text: { nor: 'Ja', eng: 'Yes' },
        is_correct: true,
      },
      {
        id: null,
        answer_text: { nor: 'Nei', eng: 'No' },
        is_correct: false,
      },
    ],
  },
  {
    id: null,
    uuid: uuid(),
    question_text: {
      nor: 'Hvor mange år har du hatt lederansvar?',
      eng: 'How many years of management experience do you have?',
    },
    type: ProcessQuestionTypeModel.MultiChoice,
    reject_on_failure: false,
    is_required: false,
    alternatives: [
      {
        id: null,
        answer_text: { nor: 'Mer enn 5 år', eng: 'More than 5 years' },
        is_correct: false,
      },
      {
        id: null,
        answer_text: { nor: 'Mer enn 1 år', eng: 'More than 1 year' },
        is_correct: false,
      },
      {
        id: null,
        answer_text: {
          nor: 'Ingen ledererfaring',
          eng: 'No experience',
        },
        is_correct: false,
      },
    ],
  },
  {
    id: null,
    uuid: uuid(),
    question_text: {
      nor: 'Snakker og skriver du flytende norsk (C1 nivå)?',
      eng: 'Are you fluent in English and 1 Scandinavian language?',
    },
    type: ProcessQuestionTypeModel.YesNo,
    reject_on_failure: false,
    is_required: false,
    alternatives: [
      {
        id: null,
        answer_text: { nor: 'Ja', eng: 'Yes' },
        is_correct: true,
      },
      {
        id: null,
        answer_text: { nor: 'Nei', eng: 'No' },
        is_correct: false,
      },
    ],
  },
  {
    id: null,
    uuid: uuid(),
    question_text: {
      nor: 'Hvilken type stilling ønsker du?',
      eng: 'What type of position are you looking for?',
    },
    type: ProcessQuestionTypeModel.MultiChoice,
    reject_on_failure: false,
    is_required: false,
    alternatives: [
      {
        id: null,
        answer_text: { nor: 'Deltid', eng: 'Part-time' },
        is_correct: false,
      },
      {
        id: null,
        answer_text: { nor: 'Heltid', eng: 'Full-time' },
        is_correct: false,
      },
    ],
  },
  {
    id: null,
    uuid: uuid(),
    question_text: {
      nor: 'Har du erfaring med å arbeide i utlandet?',
      eng: 'Do you have experience with working abroad?',
    },
    type: ProcessQuestionTypeModel.MultiChoice,
    reject_on_failure: false,
    is_required: false,
    alternatives: [
      {
        id: null,
        answer_text: {
          nor: 'Ja, mer enn 1 år',
          eng: 'Yes, more than 1 year',
        },
        is_correct: false,
      },
      {
        id: null,
        answer_text: {
          nor: 'Ja, mindre enn 1 år',
          eng: 'Yes, less than 1 year',
        },
        is_correct: false,
      },
      {
        id: null,
        answer_text: { nor: 'Nei', eng: 'No' },
        is_correct: false,
      },
    ],
  },
  {
    id: null,
    uuid: uuid(),
    question_text: {
      nor: 'Fortell kort om deg selv (navn og hva du gjør i dag)',
      eng: 'Tell a bit about yourself ',
    },
    type: ProcessQuestionTypeModel.OneWayVideo,
    reject_on_failure: false,
    is_required: false,
    alternatives: [],
  },
  {
    id: null,
    uuid: uuid(),
    question_text: {
      nor: 'Fortell en “fun fact” om deg selv :)',
      eng: 'Tell a “fun-fact” about yourself :)',
    },
    type: ProcessQuestionTypeModel.OneWayVideo,
    reject_on_failure: false,
    is_required: false,
    alternatives: [],
  },
  {
    id: null,
    uuid: uuid(),
    question_text: {
      nor: 'Hvorfor søker du stilling hos oss?',
      eng: 'Why do you want to work for us?',
    },
    type: ProcessQuestionTypeModel.OneWayVideo,
    reject_on_failure: false,
    is_required: false,
    alternatives: [],
  },
  {
    id: null,
    uuid: uuid(),
    question_text: {
      nor: 'Hva er god kunderservice for deg?',
      eng: 'What is a good customer service to you?',
    },
    type: ProcessQuestionTypeModel.OneWayVideo,
    reject_on_failure: false,
    is_required: false,
    alternatives: [],
  },
  {
    id: null,
    uuid: uuid(),
    question_text: {
      nor: 'Hva er god teamledelse for deg?',
      eng: 'What is a good team management to you?',
    },
    type: ProcessQuestionTypeModel.OneWayVideo,
    reject_on_failure: false,
    is_required: false,
    alternatives: [],
  },
  {
    id: null,
    uuid: uuid(),
    question_text: {
      nor: 'Hva motiverer deg?',
      eng: 'What motivates you?',
    },
    type: ProcessQuestionTypeModel.OneWayVideo,
    reject_on_failure: false,
    is_required: false,
    alternatives: [],
  },
  {
    id: null,
    uuid: uuid(),
    question_text: {
      nor: 'Hvorfor bør vi ansette deg',
      eng: 'Why should we hire you?',
    },
    type: ProcessQuestionTypeModel.OneWayVideo,
    reject_on_failure: false,
    is_required: false,
    alternatives: [],
  },
];
